export class FallbackImages {

    constructor() {

    }

    static fallbackImages() {
        const placeholder = "/App_Firma/img/default.jpg";
        const imagesWithoutLazyload = [...document.getElementsByTagName('img')];

        imagesWithoutLazyload.forEach(image => {

            image.addEventListener('error', () => {
                if (!image.classList.contains('loading-error')) {
                    image.src = placeholder;
                    image.classList.add('loading-error');
                }
            });

            const { src } = image;
            image.removeAttribute('src');
            image.src = src;

        });
    }
}